import React from 'react';
import { Calendar } from 'lucide-react';

const SeletorPeriodo = ({ dataInicio, dataFim, onDataInicioChange, onDataFimChange, className = '' }) => {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <div className="flex-1">
        <label htmlFor="seletor-periodo-data-inicial" className="mb-1.5 block text-xs font-medium text-[color:var(--text-muted)]">
          Data Inicial
        </label>
        <div className="relative">
          <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[color:var(--text-muted)]" />
          <input
            id="seletor-periodo-data-inicial"
            type="date"
            value={dataInicio}
            onChange={(e) => onDataInicioChange(e.target.value)}
            max={dataFim || undefined}
            className="w-full rounded-lg border border-[color:var(--border)] bg-[color:var(--surface)] py-2 pl-10 pr-3 text-sm text-[color:var(--text-primary)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)]/40"
          />
        </div>
      </div>
      
      <div className="flex-1">
        <label htmlFor="seletor-periodo-data-final" className="mb-1.5 block text-xs font-medium text-[color:var(--text-muted)]">
          Data Final
        </label>
        <div className="relative">
          <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[color:var(--text-muted)]" />
          <input
            id="seletor-periodo-data-final"
            type="date"
            value={dataFim}
            onChange={(e) => onDataFimChange(e.target.value)}
            min={dataInicio || undefined}
            max={new Date().toISOString().split('T')[0]}
            className="w-full rounded-lg border border-[color:var(--border)] bg-[color:var(--surface)] py-2 pl-10 pr-3 text-sm text-[color:var(--text-primary)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)]/40"
          />
        </div>
      </div>
    </div>
  );
};

export default SeletorPeriodo;
